import { useState } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { Outlet } from "react-router-dom";
// import { sideArray } from "./menuArray";
import { DrawerHeader } from "./style";
import Header from "./Header";
// import ContainerGlobal from "./ContainerGlobal";
// import { AlertDialogSlideContextProvider } from "../component/alert-dialog/AlertDialogProvider";
// import SideBar from "./SideBar";
import Footer from "./Footer";
import MoreButton from "./MoreButton";




const MainLayout = () => {
//   const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('dark');
//   let sideBarArray = [...sideArray];
//   const toggleSidebar = () => {
//     setOpen((prev) => !prev);
//     const body = document.querySelector("main");
//     if (body) body.style.overflowX = open ? "auto" : "hidden";
//   };

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };
  return (
    <>
      <Box >
        <CssBaseline />

        <Header mode={mode} toggleColorMode={toggleColorMode}/>

        {/* <SideBar
          open={open}
          toggleSidebar={toggleSidebar}
          sideBarArray={sideBarArray}
        /> */}

        <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        {/* <Box component="main" > */}
          <DrawerHeader />

          {/* <AlertDialogSlideContextProvider>
            <ContainerGlobal>
              <Outlet />
            </ContainerGlobal>
          </AlertDialogSlideContextProvider> */}
        
            {/* <ContainerGlobal>
              <Outlet />
            </ContainerGlobal> */}
            <Outlet />
            <Box sx={
              {  pt: { xs: 10, sm: 12 },}
            }>
            
           <MoreButton/>
           <Footer/>
           </Box>
           
         
        </Box>
      </Box>
    </>
  );
};

export default MainLayout;
